module.exports = __webpack_public_path__ + "img/ios-driver.76e40855.png";